import { showTotal } from "@utils/functions";
import type { PaginationProps as AntPaginationProps } from "antd";
import { Pagination as AntPagination } from "antd";
import React from "react";
export type PaginationProps = AntPaginationProps & {
  displayTotal?: boolean;
};
const Pagination: React.FC<PaginationProps> = ({
  displayTotal,
  ...props
}: PaginationProps) => {
  return (
    <AntPagination
      showTotal={displayTotal ? showTotal : undefined}
      {...props}
    />
  );
};
export default Pagination;
